var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "expend-more",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3466_7663",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 1,
    stroke: "#013d50",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_3466_7663)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_3466_7663",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 6,
    height: 6,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "#013d50",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-2_3466_7663)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_3466_7663",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 6,
    height: 6,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "#013d50",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-3_3466_7663)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_3466_7663",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 6,
    height: 6,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "#013d50",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-4_3466_7663)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.144b600c3fe79337e75c604d731019cf.svg";
export { ForwardRef as ReactComponent };